// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import { useEffect } from 'react';
import { useAppDispatch } from 'Hooks';
import { TOKEN_STORAGE_KEY } from 'Utils/localStorageService';
import { EndSessionFromOtherTab } from './authThunk';

// The tabs of a browser share one session through localStorage, and the browser tells every other tab when one
// of them changes it. A tab's Log Out removes the token.
const isSessionTokenRemoved = (event: StorageEvent) => event.storageArea === localStorage
  && event.key === TOKEN_STORAGE_KEY
  && Boolean(event.oldValue)
  && event.newValue === null;

// eslint-disable-next-line import/prefer-default-export
export const useCrossTabSignOut = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (_ADMIN_) return undefined;
    const onStorage = (event: StorageEvent) => {
      if (isSessionTokenRemoved(event)) dispatch(EndSessionFromOtherTab());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [dispatch]);
};
